import styled from 'styled-components';
import {getOptImage} from 'epic-ue-shared';

export const SectionWrapper = styled.div<{bgImg: string}>`
    background-image: url(${p => getOptImage({url: p.bgImg}) || ''});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    section {
        background: transparent;
        border: 0;
        padding: 40px 0 0;
        ${p => p.theme.breakpoints.up('lg')} {
            padding: 50px 0;
        }
        .card {
            ${p => p.theme.breakpoints.up('xxl')} {
                margin-top: 100px;
            }
            .button-wrapper {
                margin: 40px 0 20px;
            }
            ${p => p.theme.breakpoints.down('sm')} {
                .btn {
                    min-width: 180px;
                }
            }
        }
        &.type-card {
            padding-bottom: 0;
        }
    }
`;

export const NewsSection = styled.div`
    background-color: ${p => p.theme.ue.colors.page.background};

    .highlight-panel {
        width: 100%;
        padding: 0 15px;

        .type-full {
            max-width: 1380px;

            ${p => p.theme.breakpoints.down('sm')} {
                .highlight-content-container {
                    width: 100%;
                    text-align: center;

                    a > div,
                    .section-heading,
                    .button-wrapper {
                        text-align: inherit;
                    }
                }
            }
        }
    }
`;

export const HomepageWrapper = styled.div`
    position: relative;
    overflow: hidden;

    .caseStudies {
        .border-top {
            margin-top: 10px;
        }
        h2 {
            width: 100%;
        }
    }

    section.noPadding {
        padding: 20px 0 !important;
        min-height: 20vh;
    }
`;

export const SliderMargin = styled.div`
    margin-top: 3em;
`;

export const NewsButtonWrap = styled.div`
    width: 100%;
    margin: 2em 0;
    text-align: center;
`;

export const Clear = styled.div`
    clear: both;
    width: 100%;
    margin: 0 0 3em;
`;
